import { largestRemainderRound } from '../charts/helpers/formatters'

export const roundObj = (obj) => {
  if (!obj) return null
  const values = Object.values(obj)
  const rounded = largestRemainderRound(values)
  return Object.fromEntries(Object.entries(obj).map(([key], index) => [key, rounded[index]]))
}
